// extracted by mini-css-extract-plugin
module.exports = {"custom":"custom-module--custom--1NxhC"};